import TipoModeloDocumentoInput from '@/core/apiclient/configuracao/tipo-modelo-documento/models/TipoModeloDocumentoInput'
import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	filtro: new TipoModeloDocumentoInput(null, null),
	filtroListagem: {
		nome: {
			default: null,
			label: 'Tipo',
			value: null,
		},
	},
	paginacaoListagem: Paginacao(['dataCadastro'], 25, 'DESC'),
}
